document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('#product-highlights-slider');

  if (slider) {
    new Splide(slider, {
      type: 'loop',
      perPage: 1.2,
      gap: '12px',
      arrows: false,
      pagination: false,
      drag: false,
      autoplay: false,
      autoWidth: true,
      clones: 10,
      focus: 'center',

      autoScroll: {
        speed: 0.5,
        pauseOnHover: true,
        pauseOnFocus: false,
      },
    }).mount(window.splide.Extensions);
  }
});